import { Box, Chip, SxProps } from "@mui/material";
import Menu from "@mui/material/Menu";
import { DatePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import * as React from "react";

type DateRangeSelectProps = {
  onClick?: () => void;
  onChangeFromDate?: (value: DateTime) => void;
  onChangeToDate?: (value: DateTime) => void;
  onClose?: () => void;
  fromDate: string | null;
  toDate: string | null;
  sx?: SxProps;
};

export const DateRangeSelect = (props: DateRangeSelectProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    props?.onClick?.();
  };
  const handleClose = () => {
    setAnchorEl(null);
    props?.onClose?.();
  };

  return (
    <Box>
      <Chip sx={props.sx} onClick={handleClick} label="Custom" />
      <Menu
        anchorEl={anchorEl}
        id="date-range-menu"
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              padding: "10px",
              borderRadius: ".5rem",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            fieldset: {
              borderWidth: "1px !important",
            },
          }}
        >
          <DatePicker
            label="Start date"
            value={DateTime.fromISO(props.fromDate as string)}
            onChange={(value) => {
              props?.onChangeFromDate?.(value as DateTime);
            }}
          />

          <DatePicker
            label="End date"
            value={DateTime.fromISO(props.toDate as string)}
            onChange={(value) => {
              props?.onChangeToDate?.(value as DateTime);
            }}
          />
        </Box>
      </Menu>
    </Box>
  );
};
